const getOppositeDirectionArrayFromArray = (direction: string[])=>{
    return [direction[1], direction[0]]
}

export default getOppositeDirectionArrayFromArray;